/**
 * Originally authored by Patrick Stephan: https://www.patrickstephan.me
 * Currently owned and maintained by Alexandre Germain: https://github.com/GerkinDev
 */

import { DatatableFactory } from './classes';
export * from './classes/handlers';

export { TColumnsDefinition, TDataFn, IDataFnParams, ITableContentParam, VueDatatable } from './components/vue-datatable/vue-datatable';

export const VuejsDatatableFactory = new DatatableFactory();
